import { useScrollReveal } from '@/hooks/useScrollReveal';

const topics = [
  { tag: '深海恐怖', count: '12.6 万讨论', hot: true },
  { tag: '克苏鲁神话', count: '9.8 万讨论', hot: true },
  { tag: '异种战斗', count: '8.3 万讨论' },
  { tag: '触手美学', count: '7.1 万讨论', hot: true },
  { tag: '科幻惊悚', count: '6.5 万讨论' },
  { tag: '少女与触手', count: '5.9 万讨论' },
  { tag: '校园奇幻', count: '5.2 万讨论' },
  { tag: '星际冒险', count: '4.8 万讨论' },
  { tag: '暗黑都市', count: '4.3 万讨论' },
];

export default function TopicsSection() {
  const { ref: titleRef, visible: titleVisible } = useScrollReveal(0.12);
  const { ref: tagsRef, visible: tagsVisible } = useScrollReveal(0.06);

  return (
    <section id="topics" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div ref={titleRef} className={`text-center mb-12 ${titleVisible ? 'animate-fade-in-up' : 'animate-initial-hidden'}`}>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/60 border border-primary-200/50 mb-4">
            <i className="ri-hashtag text-primary-600 text-xs w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-primary-700 whitespace-nowrap">社区热议 · 话题广场</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <div className="w-16 h-0.5 bg-primary-500 mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-600">
            触手漫画读者社区热议话题，参与讨论分享你的看法
          </p>
        </div>

        <div ref={tagsRef} className={`flex flex-wrap justify-center gap-3 ${tagsVisible ? 'animate-fade-in-up' : 'animate-initial-hidden'}`}>
          {topics.map((topic, idx) => (
            <a
              key={idx}
              href="#comments"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 hover:bg-primary-100 text-primary-700'
                  : 'bg-background-100 border-background-200/60 hover:border-primary-200 text-foreground-700'
              }`}
            >
              {topic.hot && (
                <span className="text-xs w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-fire-line text-primary-500"></i>
                </span>
              )}
              <span className="text-sm font-medium">{topic.tag}</span>
              <span className="text-xs text-foreground-500">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}